import { REDIRECT_AREA_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useRedirectAreaList } from './hook';
import { RedirectAreaListProps } from './props';

export const RedirectAreaList = ({ filters }: RedirectAreaListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useRedirectAreaList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${REDIRECT_AREA_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
